// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lh-0";
export var buttonContainer = "_lh-3";
export var cancelButton = "_lh-4";
export var headerSection = "_lh-6";
export var headerTitle = "_lh-9";
export var messageSideLeft = "_lh-1";
export var messageSideRight = "_lh-2";
export var orderNumberContainer = "_lh-7";
export var orderNumberLabel = "_lh-8";
export var submitButton = "_lh-5";